import {bffHooks} from '@product-web/bff'

export const bff = bffHooks.helpCentre
